import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

class Lead {
  static ENDPOINT = 'api/v2/leads';

  static async getAllLeadsForDataGrid(params: any): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}`, params);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async addLead(payload: any): Promise<APIResponseType> {
    try {
      const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteLead(leadId: string): Promise<APIResponseType> {
    if (!leadId) throw new Error("Lead ID is required for deletion");
    try {
      const response = await apiService.delete<APIResponseType>(`${this.ENDPOINT}/${leadId}`);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async editLead(leadId: string, payload: Partial<any>): Promise<APIResponseType> {
    if (!leadId) throw new Error("Lead ID is required for editing");
    if (!Object.keys(payload).length) throw new Error("Edit payload cannot be empty");

    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${leadId}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default Lead; 